export const ANALYTIC_TYPE = {
  EFFICIENCY: 'EFFICIENCY',
  GUEST_INSIGHT: 'GUEST_INSIGHT',
  REVENUE_DISTRIBUTION: 'REVENUE_DISTRIBUTION',
  MARKET_DEMAND: 'MARKET_DEMAND',
};

export const ANALYTIC_TYPE_LIST = [
  {
    name: 'Hiệu suất',
    value: ANALYTIC_TYPE.EFFICIENCY,
  },
  {
    name: 'Thông tin chuyên sâu',
    value: ANALYTIC_TYPE.GUEST_INSIGHT,
  },
  {
    name: 'Phân phối doanh thu',
    value: ANALYTIC_TYPE.REVENUE_DISTRIBUTION,
  },
  {
    name: 'Nhu cầu theo thị trường',
    value: ANALYTIC_TYPE.MARKET_DEMAND,
  },
];

export const DAY_MILESTONES = {
  DAY_365: 365,
  DAY_90: 90,
  DAY_30: 30,
  DAY_14: 14,
  DAY_7: 7,
};

export const DATA_TIMES = [
  {
    label: '365 ngày qua',
    value: DAY_MILESTONES.DAY_365,
  },
  {
    label: '90 ngày qua',
    value: DAY_MILESTONES.DAY_90,
  },
  {
    label: '30 ngày qua',
    value: DAY_MILESTONES.DAY_30,
  },
  {
    label: '14 ngày qua',
    value: DAY_MILESTONES.DAY_14,
  },
  {
    label: '7 ngày qua',
    value: DAY_MILESTONES.DAY_7,
  },
];
